import styles from './button-group.module.scss';
import MaterialButtonGroup from '@mui/material/ButtonGroup';
import MaterialPopper from '@mui/material/Popper';

/* eslint-disable-next-line */
export interface ButtonGroupProps {
  children: any,
  // classes?: object,
  color?: 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  // component?: any,
  disabled?: boolean,
  // disableElevation?: boolean,
  // disableFocusRipple?: boolean,
  // disableRipple?: boolean,
  fullWidth?: boolean,
  orientation?: 'horizontal' | 'vertical',
  size?: 'small' | 'medium' | 'large',
  sx?: any,
  variant?: 'contained' | 'outlined' | 'text',
  className?: string,
  ref?: any
}

export interface PopperProps {
  open: boolean,
  anchorEl?: any,
  children?: any,
  // container?: any,
  // direction?: 'ltr' | 'rtl',
  // disablePortal?: boolean,
  // keepMounted?: boolean,
  // modifiers?: Array<{
  //   data?: object, effect?: any, enabled?: boolean, fn?: any, name: any, options?: object,
  //   phase?: 'afterMain' | 'afterRead' | 'afterWrite' | 'beforeMain' | 'beforeRead' | 'beforeWrite' | 'main' | 'read' | 'write',
  //   requires?: Array<string>,
  //   requiresIfExists?: Array<string>
  // }>,
  placement?: 'auto-end' | 'auto-start' | 'auto' | 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top',
  // popperOptions?: {
  //   modifiers?: any,
  //   onFirstUpdate?: any,
  //   placement?: 'auto-end' | 'auto-start' | 'auto' | 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top',
  //   strategy?: 'absolute' | 'fixed'
  // },
  // popperRef?: any,
  transition?: boolean
}

export function ButtonGroup(props: ButtonGroupProps) {
  return (
    <MaterialButtonGroup
      variant={props.variant}
      color={props.color}
      disabled={props.disabled}
      fullWidth={props.fullWidth}
      orientation={props.orientation}
      size={props.size}
      ref={props.ref}
      sx={props.sx}
      className={props.className}>
      {props.children}
    </MaterialButtonGroup>
  );
}

// export function SplitButton(props: ButtonGroupProps) {
//   return (
//     <ButtonGroup {...props}
//       color="primary"
//     />
//   )
// }

export function Popper(props: PopperProps) {
  return (
    <MaterialPopper
      open={props.open}
      anchorEl={props.anchorEl}
      placement={props.placement}
      transition={props.transition}>
      {props.children}
    </MaterialPopper>
  );
}

export default ButtonGroup;